import React from "react";
import { HubspotProvider } from '@aaronhayes/react-use-hubspot-form';

export const wrapPageElement = ({ element }) => {
  return <HubspotProvider>{element}</HubspotProvider>;
};
